import { Box, Stack, Typography } from '@mui/material';
import { useListContext, usePermissions, useTranslate } from 'react-admin';
import { BarChartWithTrend } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { calcGrowth, prepareTrendChartData } from '@/helpers/analytics/charts.js';
import { Growth } from '@/components/analytics/common/Growth.jsx';
import { ChartAnalyticsCard } from '@/components/analytics/common/ChartAnalyticsCard.jsx';
import { styled } from '@mui/material/styles';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';
import { NoDataPlaceholder } from '@/components/analytics/common/NoDataPlaceholder.jsx';

const StyledServiceRequestCount = styled(Stack)(() => ({
    '& .ranking-header': {
        ...analyticsStyles.rankingHeader,
    },
}));

const Title = ({ value, growth }) => {
    const translate = useTranslate();
    return (
        <StyledServiceRequestCount>
            <Box className='ranking-header' sx={{ marginBottom: '3px !important' }}>
                <Typography variant='h6'>{translate('analytics.service.requests')}</Typography>
            </Box>
            {!isFinite(value) || value === 0 ? (
                <NoDataPlaceholder />
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant='h3'>{value}</Typography>
                    <Growth value={growth} reverse={true} />
                </Box>
            )}
        </StyledServiceRequestCount>
    );
};

export const ServiceClosedCount = () => {
    const translate = useTranslate();
    const { data } = useListContext();
    const permissions = usePermissions();
    const hasAccess = !permissions?.permissions?.isService;

    if (!hasAccess || !data || data.length === 0) {
        return null;
    }

    const analytic = data.find(s => s.id === 'current').data;
    const previous = data.find(s => s.id === 'previous').data;
    const series = data.find(s => s.id === 'series').data;
    const chartData = prepareTrendChartData(series, 'serviceRequestCount');

    return (
        <ChartAnalyticsCard
            data={chartData}
            dataKey='serviceRequestCount'
            className='service-closed-count'
            stats={<Title value={analytic.serviceRequestCount} growth={calcGrowth(analytic.serviceRequestCount, previous.serviceRequestCount)} />}
            chart={
                <BarChartWithTrend
                    data={chartData}
                    dataKey='serviceRequestCount'
                    label={translate('analytics.service.closedCountLabel')}
                    className='chart-analytics-service-closed-count'
                />
            }
        />
    );
};
